import { createSelector } from "reselect";

const selectSideMenu = (state) => state.sideMenu;

export const selectSideNavToggle = createSelector(
  [selectSideMenu],
  (sideMenu) => sideMenu.sideNavToggle
);

export const selectUserMenu = createSelector(
  [selectSideMenu],
  (sideMenu) => sideMenu.sideNavMenu
);
